import React, {useState}   from 'react';
import { useSelector } from 'react-redux';
import Select from "react-select";
import {
  Card, 
  CardBody,
  Row, Col, 
  Table, Button, 
 } from "reactstrap";


var sdf = require('date-format');
var Icons = require ('Icons');

const DayAttendanceCard = ( { student, attendance, fecha, deleteAtt, calendarID, addAtt, token, close  } ) =>  {

      const [crrntAttendance, setCrrntAttendance] = useState(attendance);
      const [selectedAttendance, setSelectedAttendance] = useState({});
      const [isJustified, setIsJustified] = useState(false);


      const { attendanceTypes } = useSelector(state => ({
        attendanceTypes: state.courses.attendanceTypes
       }))

        return (
          attendanceTypes &&
            <>
            <div  key="pa" className="content">
              <Card className="card-plain">
                <CardBody>
                
                  <Row>
                     <h5>{student.studentName} - Día {sdf.asString('dd/MM', fecha)}</h5>
                       <Table responsive bordered striped size="sm">
                            <thead>
                                <tr>
                                    <th>Descripción</th>
                                    <th align="center">Cantidad</th>
                                    <th align="center">Justificada</th>
                                    <th></th>
                                </tr>
                            </thead>
                        <tbody>
                            { crrntAttendance.map( ( att, idx ) => { 
                              att.value =  parseFloat(att.qty)
                            return (
                                <>
                                <tr key={att.attendance_id}>
                                    
                                    <td>{att.description}</td>
                                    <td align="center">{ att.value===0?'-':att.value===0.5?'½':att.value }</td>
                                    <td align="center">{ att.justification==='Y'?'SI':'NO'}
                                                          </td> 
                                    <td>
                                      <Button color="danger" size="sm"
                                        disabled={!att.attendance_id}
                                        onClick={() => { 
                                                          deleteAtt( token, att.persona_id, att.attendance_id );
                                                          setTimeout(function() { 
                                                            setCrrntAttendance(crrntAttendance.filter(
                                                              (e) => ! ( e.persona_id ===  att.persona_id &&
                                                                         e.attendance_id ===  att.attendance_id ) )
                                                            )
                                                        }, 100)

                                                          
                                              } } 
                                        >
                                         <i className={Icons.REMOVE} /> Borrar
                                      </Button>
                                    </td>
                                </tr>
                                </> 
                                )
                            } ) }
                            
                        </tbody>
                      </Table>
                  </Row>
                  <Row>
                     
                    <Col className="col-md-8">
                      <Select
                                name="current"
                                // defaultValue= { attendanceTypes[0]}
                                onChange={(sel) => setSelectedAttendance(sel)}
                                options={attendanceTypes}
                                placeholder="Seleccione tipo de inasistencia"
                              />
                       {selectedAttendance&& selectedAttendance.justification==='Y'?
                          <span style={{lineHeight:"40px"}}>Esta justificada  
                          <input type="checkbox"  onClick={() => setIsJustified(!isJustified) }/> </span>
                        : <>
                       
                        </>
                        }
                    </Col>
                    <Col className="col-md-4">
                     
                      {selectedAttendance&&selectedAttendance.value &&
                        <>
                        <Button color="primary" size="sm"
                            disabled={!(selectedAttendance&&selectedAttendance.value)}
                            onClick={() => {  
                              addAtt( token, student.persona_id, calendarID, 
                                    { "date": sdf.asString('yyyy-MM-dd', fecha),
                                      "attendance_type":selectedAttendance.value, 
                                      "description": selectedAttendance.description,
                                      "qty":selectedAttendance.qty,
                                      "justified": isJustified?'Y':'',
                                      "justification_required": selectedAttendance.justification });
                              setTimeout(function() { 
                                close();
                                // setCrrntAttendance([...crrntAttendance, 
                                //               {description: selectedAttendance.description,
                                //               qty: selectedAttendance.qty
                                //               }  ] )
                                }, 100)
                          } } 
                                          >
                                          <i className={Icons.ADD} /> Agregar
                                        </Button>
                          </>
                          } 
                      
                  </Col>
                  </Row>
                </CardBody>
              </Card>
            </div>
            </>
        
        );
        }

export { DayAttendanceCard } ;
